/**
 * Stan okna zapisów. Mówi wyłącznie o oknie i stanie wyjazdu — nigdy o zajętości.
 * „Brak miejsc" front czyta osobno z `hasLimit` / `availableParticipantSpots`;
 * wartości `SOLD_OUT` nie ma i nie będzie.
 */
export enum RegistrationStatus {
  /** Wyjazd odwołany — zapisów nie będzie. */
  CANCELLED = 'CANCELLED',
  /** Nie ustawiono daty otwarcia zapisów. */
  NOT_SCHEDULED = 'NOT_SCHEDULED',
  /** Data otwarcia w przyszłości. */
  PLANNED = 'PLANNED',
  /** Okno otwarte. */
  OPEN = 'OPEN',
  /** Po rzeczywistym końcu zapisów albo wyjazd nieaktywny (szkic/archiwum). */
  CLOSED = 'CLOSED',
}
